import { has, compact } from '@ally/utilitarian';
import { toAppArray } from '.';
import { findMatchingApp } from './federator';
var hasPrefetch = function (x) { return has(x, 'prefetch'); };
var getSortValue = function (x) {
    var n = +x;
    return n || n === 0 ? n : Number.MAX_SAFE_INTEGER;
};
function prefetchSort(a, b) {
    return getSortValue(a.prefetch) - getSortValue(b.prefetch);
}
/**
 * Returns a function that will prefetch the given App object.
 * Remote apps are prefetched using a `<link rel="prefetch" ... />` element.
 * For prefetching, the browser will use the "lowest" network request priority
 * and will only prefetch items one at a time.
 */
function prefetchesApp(_a) {
    var log = _a.log, modules = _a.modules;
    return function (_a) {
        var id = _a.id, source = _a.source;
        var exists = document.head.querySelector("[data-prefetch-remote=" + id + "]");
        if (exists || modules.has(source))
            return false;
        log.debug({ message: "Adding prefetch link for " + id });
        var link = document.createElement('link');
        link.setAttribute('rel', 'prefetch');
        link.setAttribute('href', source);
        link.setAttribute('data-prefetch-remote', id);
        document.head.appendChild(link);
        return true;
    };
}
/**
 * Pre-fetches all of the apps with a `prefetch` property if
 * `options.isPrefetchingEnabled` is enabled.
 *
 * Apps are prefetched in the order of their `prefetch` property in ascending
 * order. If the current location matches, we don't want to preload the bundle
 * again (this would cause a double preload).
 */
export function prefetch(config) {
    var apps = config.apps, _a = config.isPrefetchingEnabled, isPrefetchingEnabled = _a === void 0 ? true : _a;
    if (!isPrefetchingEnabled)
        return 0;
    var current = findMatchingApp(apps, window.location.pathname);
    var prefetching = toAppArray(apps)
        .filter(hasPrefetch)
        .filter(function (app) { return app.id !== (current === null || current === void 0 ? void 0 : current.id); })
        .sort(prefetchSort);
    return compact(prefetching.map(prefetchesApp(config))).length;
}
//# sourceMappingURL=prefetch.js.map